module.exports = __webpack_public_path__ + "static/media/jsfiddleIcon.48409d75.svg";